import Comp from "./Explore";

export default Comp;
